import api from "./api";

export async function getShifts(query) {
  try {
    const res = await api.get(`shifts`, { params: query });
    return res;
  } catch (err) {
    throw err;
  }
}

export async function createShift(payload) {
  try {
    const res = await api.post(`shift`, payload);
    return res;
  } catch (error) {
    throw error;
  }
}

export async function getStaffShifts(query) {
  try {
    const res = await api.get(`staff-shifts`, { params: query });
    return res;
  } catch (err) {
    throw err;
  }
}

export async function updateShift(payload) {
  try {
    const res = await api.put(`shift/${payload.shiftId}`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getShift(id) {
  try {
    const res = await api.get(`shifts/${id}/details`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function deleteShift(shiftId) {
  if (!shiftId) {
    throw new Error("Shift ID is required for deletion");
  }

  try {
    const res = await api.delete(`shift/${shiftId}`);
    return res;
  } catch (err) {
    // Add specific error handling for common scenarios
    if (err.response?.status === 404) {
      throw new Error("Shift not found");
    } else if (err.response?.status === 403) {
      throw new Error("You don't have permission to delete this shift");
    } else if (err.response?.status === 409) {
      throw new Error("Cannot delete shift: it may have associated data or be in progress");
    } else {
      throw new Error(err.response?.data?.message || "Failed to delete shift");
    }
  }
}
